//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const defaultModels = () => [
  'flux',
  'nano-banana',
  'openai',
  'lumaai',
  'minimax',
  'elevenlabs',
  'gpt-image',
  'seedream',
  'veo',
  'kling',
];

export default {
  name: 'SubscribeHero2026AiPartners',
  props: {
    models: {
      type: Array,
      default: defaultModels,
    },
  },
  methods: {
    aiModelLogo(model) {
      return this.$cdnImg(`/img/subscribe/model-${model}.svg`);
    },
  },
};
